import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useStateContext } from "../contexts/ContextProvider";

const Orders = () => {
  const { user, allOrders, setIsScrolled, getAllOrders } = useStateContext();
  const [groupedOrders, setGroupedOrders] = useState();
  useEffect(() => {
    // Fetch all orders if user is logged in
    if (user) {
      console.log(user.email);
      getAllOrders(user.email);
    }
  }, [user]);

  useEffect(() => {
    if (allOrders) {
      // Group orders by order_id
      const groupedItems = allOrders.reduce((acc, curr) => {
        const orderId = curr.order_id;
        const existingOrder = acc.find(
          (order) => order[0].order_id === orderId
        );
        if (existingOrder) {
          existingOrder.push(curr);
        } else {
          acc.push([curr]);
        }
        return acc;
      }, []);
      setGroupedOrders(groupedItems);
    }
  }, [allOrders]);

  window.onscroll = () => {
    // Check if the page is scrolled to the top
    setIsScrolled(window.pageYOffset === 0 ? false : true);
    return () => (window.onscroll = null);
  };

  return (
    <Component>
      <h2>Your Orders</h2>
      {
        groupedOrders?.length > 0 ? 
          <OrderContainer>
        {console.log(groupedOrders)}
        {groupedOrders
          ?.slice()
          .reverse()
          .map((orderGroup) => (
            <div className="border-bottom" key={orderGroup.length}>
              <div className="header">
                <p>
                  <span>Order Date: </span>
                  {`${orderGroup[0].order_date.slice(0, 10).split("-")[2]} - ${
                    orderGroup[0].order_date.slice(0, 10).split("-")[1]
                  } - ${orderGroup[0].order_date.slice(0, 10).split("-")[0]}`}
                  <span>at:</span>{" "}
                  {orderGroup[0].order_date.split("T")[1].slice(0, 8)}
                </p>
                <p>
                  <span>Total: </span>${orderGroup[0].total_price}
                </p>
              </div>
              <div className="infoWrapper">
                <div className="infoTitleTable">
                  {orderGroup?.map((order) => (
                    <MainOrderContainer>
                      <Container>
                        <Image>
                          <img src={order.image} alt="" />
                        </Image>
                        <Info>
                          <p>{order.descr}</p>
                          <ControlButtons>
                            <Quantity>
                              <span>Qty</span>
                              <span>{order.quantity}</span>
                            </Quantity>
                            <p>${order.price}</p>
                          </ControlButtons>
                        </Info>
                      </Container>
                    </MainOrderContainer>
                  ))}
                </div>
                <div className="address-table">
                  <p>{orderGroup[0].recievers_name}</p>
                  <p>{orderGroup[0].addressLine1}</p>
                  <p>{orderGroup[0].addressLine2}</p>
                  <p>{orderGroup[0].country}</p>
                  <p>{orderGroup[0].city}</p>
                  <p>{orderGroup[0].phone_no}</p>
                </div>
              </div>
            </div>
          ))}
      </OrderContainer> 
       :
      <OrderContainer>
        No order has been placed by this account yet
      </OrderContainer> 
     
      }
   
    </Component>
  );
};

export default Orders;

const Component = styled.div`
  margin-top: 10vh;
  display: flex;
  flex-direction: column;
  h2 {
    padding-left: 10px;
  }
`;

const OrderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;

  .border-bottom {
    display: flex;
    flex-direction: column;
    width: 80vw;
    border: 1px solid #ecdcdc;
    border-radius: 10px;
    padding: 14px;
    margin-bottom: 40px;
    box-shadow: 4px 4px 5px 0px rgba(0, 0, 0, 0.29);
    -webkit-box-shadow: 4px 4px 5px 0px rgba(0, 0, 0, 0.29);
    -moz-box-shadow: 4px 4px 5px 0px rgba(0, 0, 0, 0.29);
    .infoWrapper {
      display: flex;

      @media (max-width: 781px) {
        flex-direction: column;
      }
    }
    .header {
      display: flex;
      height: 30px;
      align-items: center;
      justify-content: flex-start;
      span {
        font-size: 12px;
        margin-right: 2px;
      }
      p {
        margin-right: 30px;
        margin-left: 20px;
      }
      @media (max-width: 781px) {
        p {
          font-size: 12px;
          margin-left: 2px;
        }
      }
    }
    .address-table {
      width: 20vw;
      display: flex;
      font-size: 13px;
      line-height: 2px;
      padding: 4px;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      background-color: #f1f1f1;
      @media (max-width: 481px) {
        width: 100%;
      }
    }

    .infoTitleTable {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-direction: column;
    }
  }
`;

const MainOrderContainer = styled.div`
  width: 60vw;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  @media (max-width: 781px) {
    align-items: center;
    justify-content: center;
    width: 90vw;
  }
`;

const Container = styled.div`
  display: flex;
  width: 60vw;
  padding-bottom: 10px;
  border-bottom: 1px solid #a0a0a0;
  @media (max-width: 781px) {
    align-items: center;
    justify-content: space-between;
    width: 80vw;
  }
`;
const Image = styled.div`
  width: 25%;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    object-fit: contain;
    height: 100px;
    width: 100px;
  }
`;
const Info = styled.div`
  width: 60%;
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  align-items: flex-start;
  @media (max-width: 781px) {
    p {
      font-size: 12px;
    }
  }
`;
const Price = styled.div`
  text-align: right;
  width: 15%;
`;

const Quantity = styled.div`
  display: flex;
  background-color: #ffffff;
  width: 61px;
  padding: 2px;
  border-radius: 5px;
  span {
    margin-right: 4px;
  }
`;

const ControlButtons = styled.div`
  display: flex;
  align-items: center;

  p {
    margin-left: 20px;
    padding-left: 14px;
    border-left: 1px solid #777676;
    font-size: 14px;
  }
`;
